import { render, staticRenderFns } from "./OchartDialog.vue?vue&type=template&id=df0928d4"
import script from "./OchartDialog.vue?vue&type=script&lang=js"
export * from "./OchartDialog.vue?vue&type=script&lang=js"
import style0 from "./OchartDialog.vue?vue&type=style&index=0&id=df0928d4&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports